import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PlanComponent } from './plan.component';
import { PlanEditComponent } from '../plan-edit/plan-edit.component';
import { PlanDrawComponent } from '../plan-draw/plan-draw.component';

const routes: Routes = [
  {
    path: '',
    component: PlanComponent,
    data: { title: 'Pläne' }
  },
  {
    path: 'new',
    component: PlanEditComponent,
    data: { title: 'Neuer Plan' }
  },
  {
    path: 'draw',
    component: PlanDrawComponent,
    data: { title: 'Plan zeichnen' }
  },
  {
    path: 'draw/:id',
    component: PlanDrawComponent,
    data: { title: 'Plan zeichnen bearbeiten' }
  },
  {
    path: ':id',
    component: PlanEditComponent,
    data: { title: 'Plan Bearbeiten' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PlanRoutingModule { }




























